import React from 'react';
import PropTypes from 'prop-types';
import clx from 'classnames';

// Component
import disableScreenScrolling from '@stubhub/react-disable-screen-scrolling';
import ModalMask from '@stubhub/react-modal-mask';
import ReactPortal from '@stubhub/react-portal';
// HOC

// Css
import '../styles/index.scss';

const ModalMaskDisable = disableScreenScrolling(ModalMask);
const MODAL_CLASS = 'ModalDialog';

const ModalDialog = ({onClose, closable, children, responsive, className, scrollable, rounded, blurredBackground}) => {
  const closeElement = closable && <div className={`${MODAL_CLASS}__close`} onClick={onClose} />;
  const outerClick =
    closable && onClose
      ? (e) => {
          if (e.target.parentElement.classList.contains(MODAL_CLASS)) {
            onClose(e);
          }
        }
      : null;
  const ModalMaskCmp = scrollable ? ModalMask : ModalMaskDisable;
  const outerClasses = clx(MODAL_CLASS, {
    [`${MODAL_CLASS}--blurred-background`]: blurredBackground,
  });
  const innerClasses = clx(`${MODAL_CLASS}__content`, className, {
    [`${MODAL_CLASS}__content--responsive`]: responsive,
    [`${MODAL_CLASS}__content--rounded`]: rounded,
  });

  return (
    // Here we are wrapping up modal dialog to React Portal
    <ReactPortal>
      <div className={outerClasses} onClick={outerClick}>
        <ModalMaskCmp>
          <div className={innerClasses}>
            {children}
            {closeElement}
          </div>
        </ModalMaskCmp>
      </div>
    </ReactPortal>
  );
};

ModalDialog.propTypes = {
  closable: PropTypes.bool,
  children: PropTypes.element.isRequired,
  onClose: PropTypes.func,
  responsive: PropTypes.bool,
  className: PropTypes.string,
  scrollable: PropTypes.bool,
  rounded: PropTypes.bool,
  blurredBackground: PropTypes.bool,
};

ModalDialog.defaultProps = {
  closable: true,
  responsive: false,
  scrollable: false,
  rounded: false,
  blurredBackground: false,
};

export default ModalDialog;
